import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import VideosPage from './pages/VideosPage';
import PhotosPage from './pages/PhotosPage';
import GalleryPage from './pages/GalleryPage';
import AchatPage from './pages/AchatPage';
import VentePage from './pages/VentePage';
import AdminPanel from './components/AdminPanel';
import AppInstallPrompt from './components/AppInstallPrompt';
// import InstallInstructions from './components/InstallInstructions';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={
          <Layout>
            <HomePage />
          </Layout>
        } />
        <Route path="/videos" element={
          <Layout>
            <VideosPage />
          </Layout>
        } />
        <Route path="/photos" element={
          <Layout>
            <PhotosPage />
          </Layout>
        } />
        <Route path="/gallery" element={
          <Layout>
            <GalleryPage />
          </Layout>
        } />
        <Route path="/achat" element={
          <Layout>
            <AchatPage />
          </Layout>
        } />
        <Route path="/vente" element={
          <Layout>
            <VentePage />
          </Layout>
        } />
        <Route path="/admin" element={<AdminPanel />} />
      </Routes>
      <AppInstallPrompt />
      {/* <InstallInstructions /> */}
    </Router>
  );
}

export default App;